import axios from '@axios'

const get = (url, commit, commitKey, responseKey = null, queryParams = {}) => new Promise((resolve, reject) => {
  axios.get(url, { params: queryParams })
    .then(response => {
      commit(commitKey, responseKey ? response.data[responseKey] : response.data)
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})

export default {
  doctorateStat({ commit }) {
    return get('/inno-statistics/doctorate_stat', commit, 'SET_DOCTORATE_STAT')
  },
  orgCountByTypeAndOrgAdmin({ commit }) {
    return get('/statistics/org_count_by_type_and_org_admin', commit, 'SET_ORG_COUNT_BY_TYPE_AND_ORG_ADMIN')
  },
  orgCountByRegionAndType({ commit }) {
    return get('/statistics/org_count_by_region_and_type', commit, 'SET_ORG_COUNT_BY_REGION_AND_TYPE')
  },
  countByApplyDocResearcherRegion({ commit }) {
    return get('/statistics/count_by_apply_doc_researcher_region', commit, 'COUNT_BY_APPLY_DOC_RESEARCHER_REGION')
  },
  countByDirection({ commit }) {
    return get('/statistics/count_apply_doc_by_direction', commit, 'COUNT_BY_DIRECTION')
  },
  countByApplyDocResearcherRegionOrg({ commit }, regionId) {
    return get(`/statistics/count_by_apply_doc_researcher_region?region_id=${regionId}`, commit, 'COUNT_BY_APPLY_DOC_RESEARCHER_REGION_ORG')
  },
  countByApplyDocResearcherOrganizationDirection({ commit }, orgId) {
    return get(`/statistics/count_apply_doc_by_direction?org_id=${orgId}`, commit, 'COUNT_BY_APPLY_DOC_RESEARCHER_REGION_DIRECTION')
  },
  appliedYearCount({ commit }) {
    return get('/statistics/applied_year_count', commit, 'APPLIED_YEAR_COUNT')
  },
  userCount({ commit }) {
    return get('/statistics/user_count', commit, 'USER_COUNT')
  },
  applyDocStatistics({ commit }) {
    return get('/statistics/appy_doc_statistics', commit, 'APPLY_DOC_STATISTICS')
  },
  appliedDocCountByOrganization({ commit }, queryParams = {}) {
    return get('/statistics/applied_doc_count_by_org', commit, 'APPLIED_DOC_COUNT_BY_ORG', null, queryParams)
  },
  appliedDocCountByDirection({ commit }, queryParams = {}) {
    return get('/statistics/applied_doc_count_by_direction', commit, 'APPLIED_DOC_COUNT_BY_DIRECTION', null, queryParams)
  },
  findOrgByDirection({ commit }, queryParams) {
    return axios.get('/statistics/find_org_by_direction', { params: queryParams })
      .then(response => {
        commit('ORGANIZATION_OF_DIRECTION', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  ministryReport(_, letterId) {
    return new Promise((resolve, reject) => {
      axios.get('/statistics/ministry_report', { params: { letter_id: letterId } })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  distributedQuote(_, periodId) {
    return new Promise((resolve, reject) => {
      axios.get('/statistics/distributed_quote', { params: { period_id: periodId } })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  appliedDocAndLanguageCertificate(_, periodId) {
    return axios.get('/statistics/applied_doc_and_language_certificate', { params: { period_id: periodId } })
  },
  getOrgAdvisorsStat() {
    return axios.get('/org-statistics/advisors-stat')
  },
  getMinAdvisorsStat() {
    return axios.get('/ministry-statistics/advisors-stat')
  },
  getOrgDirectionStat() {
    return axios.get('/org-statistics/direction-stat')
  },
  getMinDirectionStat() {
    return axios.get('/ministry-statistics/direction-stat')
  },
  getOrgDoctorateStat() {
    return axios.get('/org-statistics/doctorate_stat')
  },
  getMinDoctorateStat() {
    return axios.get('/ministry-statistics/doctorate_stat')
  },
  getOrgEduTypeStat() {
    return axios.get('/org-statistics/edu-type-stat')
  },
  getMinEduTypeStat() {
    return axios.get('/ministry-statistics/edu-type-stat')
  },
  getOrgQuarterApplicantStat() {
    return axios.get('/org-statistics/quarter-applicant-stat')
  },
  getMinQuarterApplicantStat() {
    return axios.get('/ministry-statistics/quarter-applicant-stat')
  },
}
